<template>
  <div>
    <div class="box info-box">
        <div class="box-header with-border">
            <h3 class="box-title">Recent Loan Disbursed</h3>

            <div class="box-tools pull-right">
            <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
            </button>
            <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button>
            </div>
        </div>
        <!-- /.box-header -->
        <div class="box-body">
            <vue-good-table
                :columns="columns"
                :rows="rows"
                styleClass="vgt-table condensed"
                :pagination-options="{
                  enabled: true,
                  perPage: 10,
                  perPageDropdown: [10, 20, 30],
                }"
                :search-options="{
                  enabled: true,
                  trigger: 'enter',
                }"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'plan_name'">
                    {{ planName(props.row.plan) }}
                  </span>
                  <span v-if="props.column.field == 'plan_amt'">
                    {{ planAmt(props.row.plan) }}
                  </span>
                  <span v-if="props.column.field == 'DisbursementDate'">
                    {{props.row.disbursementDate | myDate}}
                  </span>
                  <span v-if="props.column.field == 'EmiStartDate'">
                    {{props.row.emiStartDate | myDate}}
                  </span>
                  <span v-if="props.column.field == 'EmiEndDate'">
                    {{props.row.emiEndDate | myDate}}
                  </span>
                  <span v-if="props.column.field == 'collection_Center'">
                    <button
                      v-if="props.row.collection_center"
                      @click="viewGroupMember(props.row.collection_center.id)"
                      class="btn btn-xs btn-info"
                    >
                      {{ props.row.collection_center.name }}
                    </button>
                  </span>
                  <span v-if="props.column.field == 'Status'">
                    <span
                      v-if="props.row.status == 'pending'"
                      class="label label-warning"
                      >Pending</span
                    >
                    <span
                      v-if="props.row.status == 'disbursed'"
                      class="label label-success"
                      >Disbursed</span
                    >
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
            </vue-good-table>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'my-component',
  data () {
    return {
      totalAmt: 0,
      columns: [
        {
          label: 'PLAN Name',
          field: 'plan_name'
        },
        {
          label: 'Amount',
          field: 'plan_amt'
        },
        {
          label: 'Dis. Date',
          field: 'DisbursementDate'
        },
        {
          label: 'EMI Start Date',
          field: 'EmiStartDate'
        },
        {
          label: 'EMI End Date',
          field: 'EmiEndDate'
        },
        {
          label: 'MEMBER',
          field: 'member.name'
        },
        {
          label: 'AGENT',
          field: 'agent.name'
        },
        {
          label: 'MODE',
          field: 'branch_ledger.ledger.name'
        },
        {
          label: 'STATUS',
          field: 'Status'
        }
      ],
      rows: []
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    planName (plan) {
      var pln = JSON.parse(plan)
      return pln.name
    },
    planAmt (plan) {
      var pln = JSON.parse(plan)
      return pln.amount
    },
    loadData () {
      let loader = this.$loading.show()
      this.$axios
        .get('disbursement?status=disbursed&searchTerm=individual', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          loader.hide()
          this.rows = data.data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },

  created () {
    this.loadData()
  }
}
</script>
<style scoped>
.info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
</style>




// WEBPACK FOOTER //
// recentdisbursment.vue?5a670ccb